'use strict';

(function($) {

    var pluginName = 'kumsalCropper';

    // plugin setup
    $.fn[pluginName] = function(options) {
        if ($(this).length === 0) {
            return;
        }

        // global variables
        var cropper = this;


        var Plugin = {
            isInit: false,
            modal: null,
            cropper: null,
            aspectRatio: NaN,
            submit: function()
            {
                swal.fire({
                    title: _translation.cropper.crop.title,
                    text: _translation.cropper.crop.text,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: _translation.cropper.crop.buttons.confirm,
                    cancelButtonText: _translation.cropper.crop.buttons.cancel,
                    showLoaderOnConfirm: true,
                    allowOutsideClick: function() {
                        return !swal.isLoading();
                    },
                    preConfirm: function () {
                        return new Promise(function (resolve) {
                            $.ajax({
                                url: cropper.modal.find('.kumsal-cropper-form').attr('action'),
                                type: cropper.modal.find('.kumsal-cropper-form').attr('method'),
                                data: cropper.modal.find('.kumsal-cropper-form').serialize()
                            }).always(function(status) {
                                if(typeof status.status === 'boolean' && status.status)
                                {
                                    swal.fire({
                                        type: 'success',
                                        title: _translation.cropper.crop.success.title,
                                        html: _translation.cropper.crop.success.text,
                                        confirmButtonText: _translation.datatable.buttons.okey,
                                    });
                                    cropper.modal.modal('hide');
                                }
                                else
                                {
                                    swal.fire({
                                        type: 'error',
                                        title: _translation.datatable.action.failed.title,
                                        html: _translation.datatable.action.failed.text,
                                        confirmButtonText: _translation.datatable.buttons.okey,
                                    });
                                }
                            })
                        })
                    },
                }).then(function(result){

                    if (result.dismiss === 'cancel') {

                        swal.fire({
                            type: 'error',
                            title: _translation.datatable.action.cancel.title,
                            html: _translation.datatable.action.cancel.text,
                            confirmButtonText: _translation.datatable.buttons.okey,
                        });
                    }
                });
            },
            initModalEvents: function(){
                cropper.modal.on('hidden.bs.modal', function (e) {
                    cropper.modal.remove();
                });
                cropper.modal.on('click','.btn-primary', function (e) {
                    e.preventDefault();
                    cropper.submit();
                });
                cropper.modal.on('submit','.kumsal-cropper-form', function (e) {
                    cropper.submit();
                    return false;
                });
            },
            initCropper: function()
            {
                var options = {
                    crop: function(event) {
                        cropper.modal.find('input[name=x]').val(Math.round(event.detail.x));
                        cropper.modal.find('input[name=y]').val(Math.round(event.detail.y));
                        cropper.modal.find('input[name=width]').val(Math.round(event.detail.width));
                        cropper.modal.find('input[name=height]').val(Math.round(event.detail.height));
                    },
                    viewMode: 1,
                    aspectRatio:cropper.aspectRatio,
                    data: {
                        x:parseInt(cropper.modal.find('input[name=x]').val()),
                        y:parseInt(cropper.modal.find('input[name=y]').val()),
                        width:parseInt(cropper.modal.find('input[name=width]').val()),
                        height:parseInt(cropper.modal.find('input[name=height]').val()),
                    }
                };

                $(cropper.modal.find('.kumsal-cropper-image')[0]).on('load',function() {
                    setTimeout(function(){
                        swal.close();
                        cropper.cropper = new Cropper(cropper.modal.find('.kumsal-cropper-image')[0], options);
                    }, 200);
                });
            },
            initModal: function(){
                swal.fire({
                    type: 'info',
                    title: _translation.datatable.loading.title,
                    html: _translation.datatable.loading.text,
                    onBeforeOpen: function(){
                        swal.showLoading();
                    },
                    allowOutsideClick: function(){
                        return !swal.isLoading();
                    },
                });



                $.ajax({
                    url: $(cropper).attr('href'),
                    type: 'GET',
                }).always(function(response) {

                    if(typeof response.status === 'boolean' && response.status)
                    {
                        cropper.modal = $('body').append(response.modal).children('.modal:last-child');

                        cropper.modal.modal('show');

                        cropper.initModalEvents();
                        cropper.initCropper();

                    }
                    else
                    {
                        swal.fire({
                            type: 'error',
                            title: _translation.datatable.action.failed.title,
                            html: _translation.datatable.action.failed.text,
                            confirmButtonText: _translation.datatable.buttons.okey,
                        });
                    }
                });

            },
            init: function() {

                cropper.initModal();

                return cropper;
            },
        };

        /**
         * Public API methods can be used directly by datatable
         */
        $.each(Plugin, function(funcName, func) {
            cropper[funcName] = func;
        });

        // initialize main datatable plugin
        if (typeof options !== 'undefined')
        {
            if (typeof options.aspectRatio !== 'undefined')
            {
                cropper.aspectRatio = options.aspectRatio;
            }
        }

        if (!cropper.isInit){
            cropper.init();
        }

        return cropper;
    };

}(jQuery));

$('document').ready(function () {

    $(document).on('click',".kumsal-media-cropper",function( event ) {
        event.preventDefault();

        var options = $(this).data();
        
        try {
            if(typeof options.aspectRatio  != "undefined" && options.aspectRatio !== '0')
            {
                $(this).kumsalCropper(options);
            }
        }
        catch (e) {
            
        }
    });
});